import { type FC, useMemo } from 'react';

import { useMediaQuery } from '@/hooks/useMediaQuery';

import * as S from './ServicePeriodSkeleton.styles';

type ServicePeriodSkeletonProps = {
  count?: number;
};

export const ServicePeriodSkeleton: FC<ServicePeriodSkeletonProps> = ({
  count = 4
}) => {
  const isMobile = useMediaQuery('mobile');

  const chipHeight = isMobile ? 64 : 72;
  const chipMinWidth = isMobile ? 86 : 107;

  const chips = useMemo(() => Array.from({ length: count }), [count]);

  return (
    <S.Wrapper
      $isMobile={isMobile}
      data-testid="service-period-skeleton"
      aria-hidden="true"
    >
      <S.Header>
        <S.SkeletonLine width={20} height={12} />
      </S.Header>

      <S.Chips>
        {chips.map((_, i) => (
          <S.Chip
            key={`period-chip-skeleton-${i}`}
            style={{ minWidth: chipMinWidth, height: chipHeight }}
          >
            <S.SkeletonLine width={45} height={10} />

            <S.SkeletonLine width={30} height={10} />

            <S.SkeletonLine width={41} height={10} />
          </S.Chip>
        ))}
      </S.Chips>
    </S.Wrapper>
  );
};
